<template>
  <v-card width="400" outlined elevation="12">
    <v-card-title>New Event</v-card-title>
    <v-card-text>
      <!-- {{this.ac}} -->
      <v-form v-model="isValid">
        <v-text-field
          v-model="happShortName"
          :counter="6"
          outlined
          label="Short Name"
          prepend-inner-icon="mdi-text-box-outline"
          placeholder="Short Name"
          required
          :rules="[
            (v) => !!v || 'Short name is required',
            (v) => (v && v.length < 7) || 'Max length 6',
          ]"
        ></v-text-field>
        <v-text-field
          v-model="happName"
          :counter="50"
          outlined
          label="Event Name"
          prepend-inner-icon="mdi-text-box-plus-outline"
          placeholder="Event Name"
          required
          :rules="[
            (v) => !!v || 'Event name is required',
            (v) => (v && v.length < 51) || 'Max length 50',
          ]"
        ></v-text-field>

        <v-select
          v-model="happCategoryId"
          :items="categories"
          :item-value="categories.value"
          label="Select category"
          dense
          outlined
        ></v-select>
        <!-- <v-btn small>Hide Location</v-btn> -->
        <v-card justify="space-around">
          <v-card-title>Location data</v-card-title>
          <v-text-field
            v-model="locationName"
            :counter="40"
            outlined
            label="Location Name"
            prepend-inner-icon="mdi-text-box-plus-outline"
            placeholder="Location Name"
            required
            :rules="[
              (v) => !!v || 'Location name is required',
              (v) => (v && v.length < 41) || 'Max length 40',
            ]"
          ></v-text-field>
          <v-card-subtitle>Zoom and double click..</v-card-subtitle>
          <div v-if="posInitiated">
            <SelectMapPosition
              v-bind="postposition"
              @pos_changed="selectedPosition"
            ></SelectMapPosition>
          </div>
          <v-row>
            <v-col>
              <v-text-field
                v-model="lat"
                outlined
                type="Number"
                label="Latitude"
                prepend-inner-icon="mdi-map-marker-plus-outline"
                placeholder="Latitude example: 59.6726"
                required
                disabled
              ></v-text-field>
              <!-- :rules="[
                  (v) => !!v || 'Latitude must be a desimal number',
                  (v) => (v && v.length < 21) || 'Max length 20',
                ]" -->
            </v-col>
            <v-col>
              <v-text-field
                v-model="lon"
                outlined
                type="Number"
                label="Longitude"
                prepend-inner-icon="mdi-map-marker-plus-outline"
                placeholder="Longitude example: 9.5395"
                required
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card >
            <v-row justify="center">
              <v-col cols="1"></v-col>
              <v-col>
            <Flags
              v-bind="post"
              @valueChangedMethodInComponent="setValueMethodInView"
              v-if="true"
            ></Flags>
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </v-card>
          <!-- <v-card-actions><v-btn small>Hide Location</v-btn></v-card-actions> -->
        </v-card>
        <div>.</div>
        <v-card>
          <v-label>Select a date or from date - to date.</v-label>
          <v-date-picker v-model="dates" range justify="center"></v-date-picker>
          <!-- <div>.</div>
      {{dates}}
      <v-spacer></v-spacer> -->
          <v-row>
            <!-- v-if="dates.length==1" -->
            <v-col></v-col>
            <v-chip color="primary" small>{{ dates[0] }}</v-chip>
            <v-chip color="primary" small>{{ dates[1] }}</v-chip>
            <v-col></v-col>
          </v-row>
        </v-card>
        <div>.</div>
        <v-textarea
          v-model="happDescription"
          :counter="5000"
          outlined=""
          prepend-inner-icon="mdi-text-box-plus-outline"
          placeholder="Description"
          required
          :rules="[
            (v) => !!v || 'Description is required',
            (v) => (v && v.length < 5001) || 'Max length 5000',
          ]"
        ></v-textarea>

        <!-- {{valueInComponent}} -->
        <!-- </div> -->
        <v-row class="d-flex justify-space-around">
          <v-col> </v-col>
          <v-col>
            <v-btn :disabled="!isValid" color="primary" @click="submit" rounded
              >Submit</v-btn
            >
          </v-col>
          <v-col>
            <v-btn color="lightgrey" link to="/eventlist" rounded
              >Cancel</v-btn
            >
          </v-col>
          <!-- :to="cancellink.to" -->
        </v-row>
        <div>.</div>
        <v-alert type="success" :value="isAlertVisible">
          {{ statusResultMsg }} <v-spacer></v-spacer
        ><v-btn rounded small to="/eventlist" color="primary">OK</v-btn>
        </v-alert>
        <v-alert type="warning" :value="isWarningAlertVisible">
          {{ statusResultMsg }}<v-spacer></v-spacer
        ><v-btn rounded small to="/eventlist" color="primary">OK</v-btn>
        </v-alert>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import SelectMapPosition from "@/components/airbox/SelectMapPosition.vue";

export default {
  name: "RegForm",
  props: {
    box: [],
    regId: Number,
    ac: String,
  },
  data: () => ({
    happShortName: null,
    happName: null,
    happDescription: null,
    locationName: null,
    lat: null,
    lon: null,
    isValid: true,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    select: null,
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: { to: "/" },
    text: String,
    showComponent: Boolean,
    compValue: String,
    valueInComponent: String,

    categories: [
      { text: "Hike&Fly", value: 1 },
      { text: "Fun Cup", value: 2 },
      { text: "Competition", value: 3 },
      { text: "Other", value: 4 },
    ],
    happCategoryId: Number,

    fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dates: [],
    menu: false,
    modal: false,
    menu2: false,
    modal2: false,
    post: { id: Number, text: String },

    postposition: {
      ilat: Number,
      ilng: Number,
      izoom: Number,
    },
    posSelected: Boolean,
    posInitiated: Boolean,
    selectedLat: Number,
    selectedLng: Number,
    showLocation: Boolean,
  }),

  created() {
    //this.baseUrl = "http://localhost:3000/dbapi/"; //https://pgbox.azurewebsites.net:3000/
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.happshortname = null;
    // this.happname = null;
    // this.locationname = null;
    // this.happdescription = null;
    this.statusResult = null;
    this.statusResultMsg = null;
    this.valueInComponent = "no";
    this.happCategoryId = 4;
    this.setNationCode();
    this.selectedLat = null;
    this.selectedLng = null;
    this.posSelected = false;
    this.posInitiated = false;
    this.setInitPosition();
    this.showLocation = true;
  },
  methods: {
    submit() {
      var regId = this.regId;
      var ac = this.ac;
      var happShortName = this.happShortName;

      var happName = this.happName;
      var happCategoryId = this.happCategoryId;
      // this.classes.find(obj => obj.text == item.categories).value;
      var startDate = this.dates[0]; //this.fromDate;
      if (this.dates.length < 1) {
        startDate = this.fromDate;
      }
      var endDate = this.dates[1]; //this.toDate;
      if (this.dates.length < 2 || this.dates.length == 1) {
        endDate = startDate;
      }
      var locationName = this.locationName;
      var description = this.happDescription;
      var lat = this.lat;
      var lon = this.lon;
      //   var countryCode = "no";
      var countryCode = this.valueInComponent;
      var toSubmit = JSON.stringify({
        regId,
        ac,
        happShortName,
        happName,
        happCategoryId,
        startDate,
        endDate,
        locationName,
        description,
        lat,
        lon,
        countryCode,
      });
      const uri = this.baseUrl + "newhapp";
      console.log("uri:", uri);
      console.log("toSubmit:", toSubmit);
      this.postRegistration(uri, toSubmit);
    },

    postRegistration(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          console.log("response", response.data);
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setNationCode() {
      this.post.id = 1;
      this.post.text = "no";
    },
    setValueMethodInView(value) {
      this.valueInComponent = value;
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    selectedPosition(pos) {
      // console.log("selectedPosition",pos);
      this.selectedLat = pos.lat;
      this.selectedLng = pos.lng;
      this.lat = pos.lat;
      this.lon = pos.lng;
      this.posSelected = true;
    },
    setInitPosition() {
      this.postposition.ilat = 59.5074;
      this.postposition.ilng = 9.9072;
      this.postposition.izoom = 8;
      //   console.log("postposition", this.postposition);
      this.posInitiated = true;
    },
  },
  components: {
    Flags: () => import("@/components/Admin/Flags.vue"), //Denne rendrer ved behov <div v-if..>
    SelectMapPosition,
  },
};
</script>